<div class="footer-stepper">
  <div *ngIf="showControlTowerButtons" class="footer-buttons-start">
    <button class="terminate-button" type="button" (click)="onTerminateLoadClick()" [disabled]="isDisabled || isReadOnly" [class.disabled]="isDisabled || isReadOnly">Terminate Load</button>
    <button class="view-all-link" type="button" (click)="onViewDocumentsClick()">View Documents</button>
    <button class="terminate-button" type="button" (click)="onTerminateJobClick()" [disabled]="isReadOnly" [class.disabled]="isReadOnly">Terminate Job</button>
  </div>
  <div class="stepper">
    <ng-container *ngFor="let step of steps; let i = index">
      <!-- Step -->
      <div
        class="step"
        [class.active]="i === activeStepIndex"
        [class.completed]="i < activeStepIndex"
        [class.locked]="isStepLocked(i)"
        [attr.aria-disabled]="isStepLocked(i) ? true : null"
        [matTooltip]="isStepLocked(i) ? 'Loads were terminated during planning, so this job cannot go beyond Load Assignment' : ''"
        [matTooltipDisabled]="!isStepLocked(i)"
        (click)="setActiveStep(i, step)"
        (keydown.enter)="setActiveStep(i, step)"
        role="button"
        tabindex="0"
        [attr.aria-current]="i === activeStepIndex ? 'step' : null"
        [attr.aria-label]="'Go to step ' + (i + 1) + ': ' + step"
      >
        <span class="num">{{ i + 1 }}</span><span class="title">{{ step }}</span>
      </div>
      
      <!-- Connector after step -->
      <div
        *ngIf="i < steps.length - 1"
        class="connector"
        [class.completed]="i < activeStepIndex"
        aria-hidden="true"
      ></div>
      
    </ng-container>
  </div>
  <div  class="footer-buttons">
    <button 
    *ngIf="displayOptimizeButton()"
    class="primary-button row ai-c" 
    type="button" 
    (click)="onPrimaryButtonClick()" 
    [disabled]="isOptimizing || isJobTerminated"
    [class.disabled]="isOptimizing || isJobTerminated">
    Optimize <i class="material-icons">flash_on</i>
  </button>
      <button *ngIf="displaySecondaryButton()" class="secondary-button" type="button" (click)="onSecondaryButtonClick()">{{ getSecondaryButtonText() }}</button>
      <button *ngIf="displayPrimaryButton()" class="primary-button row ai-c" type="button" (click)="onPrimaryButtonClick()" [disabled]="getPrimaryButtonDisabled()" [class.disabled]="getPrimaryButtonDisabled()">
        <span>{{ getPrimaryButtonText() }}</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
      <button *ngIf="showControlTowerButtons" class="view-all-link" type="button" (click)="onGenerateInvoiceClick()" [disabled]="isGenerateInvoiceDisabled()" [class.disabled]="isGenerateInvoiceDisabled()">Generate Invoice</button>
      <span *ngIf="showControlTowerButtons"
            class="tooltip-wrapper"
            [matTooltip]="isLoadingInvoiceInfo ? 'Generating Invoice and Payment Details' : ''"
            [matTooltipDisabled]="!isLoadingInvoiceInfo">
        <button class="view-all-link view-invoice-info" type="button" (click)="onViewUpdateInvoiceInfoClick()" [disabled]="isViewUpdateInvoiceInfoDisabled()" [class.disabled]="isViewUpdateInvoiceInfoDisabled()">
          <mat-spinner *ngIf="isLoadingInvoiceInfo" diameter="16" class="button-spinner"></mat-spinner>
          <span [class.spinner-margin]="isLoadingInvoiceInfo">View Update Invoice Information</span>
        </button>
      </span>

  </div>

</div>